// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__XWoa6","select":"Header_select__30ag6","clinic":"Header_clinic__2imfk"};